import { $body, $window, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.init();
    }

    init() {
        this.$el.on('click.HeaderBurger', event => {
            $document.trigger('toggle.HeaderNavigation');
        });
    }

    destroy() {
        this.$el.off('.HeaderBurger');
    }
}
